import { useMemo } from "react";
import { AddressBookContactSource } from "./Overview";
import { SourceFilter, SourceSelectorValue } from "../SourceSelector";
import { isNil, isNotNil } from "client/Misc/utils";
import { ContactSource } from "client/Api/Email/contacts";
import { never } from "client_legacy/ndaw/errors";

export function useContactSourceValue(
	source: AddressBookContactSource,
	department?: string,
	officeLocation?: string
): SourceSelectorValue;
export function useContactSourceValue(
	source: AddressBookContactSource | undefined,
	department?: string,
	officeLocation?: string
): SourceSelectorValue | undefined;
export function useContactSourceValue(
	source: AddressBookContactSource | undefined,
	department?: string,
	officeLocation?: string
): SourceSelectorValue | undefined {
	return useMemo(
		(): SourceSelectorValue | undefined => {
			if (isNil(source)) {
				return undefined;
			}

			switch (source) {
				case ContactSource.Gal:
				case ContactSource.Personal:
					return { source };
				case ContactSource.Workspace:
					let filter: SourceFilter | undefined;

					if (isNotNil(department)) {
						filter = {
							kind: "department",
							value: department
						};
					}

					if (isNotNil(officeLocation)) {
						filter = {
							kind: "officeLocation",
							value: officeLocation
						};
					}

					return {
						source,
						filter
					};
				default:
					never(source);
			}
		},
		[
			source,
			department,
			officeLocation
		]
	);
}